<template>
  <div v-if="careerStats">
    <div class='career-stats-cell'>
      <div>{{ gameDate }}</div>
      <div>{{ $t(`teamName.${careerStats.team}`) }}</div>
      <div>{{ careerStats.frequency }}</div>
      <div>{{ careerStats.rebound }}</div>
      <div>{{ careerStats.assists }}</div>
      <div>{{ careerStats.steal }}</div>
      <div>{{ careerStats.blockShots }}</div>
      <div>{{ careerStats.point }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'career-stats-cell',
  props: {
    careerStats: {
      type: Object,
      required: true
    }
  },
  computed: {
    gameDate () {
      return this.careerStats.gameDate !== 'Career' ? this.careerStats.gameDate : this.$t('playerCareerStats.career')
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../styles'

.career-stats-cell
  @extend %titleRow
  display: flex
  color: #333333
  min-height: 44px

  div:nth-child(1)
    width: vw(44)
    text-align: initial
    white-space: nowrap

  div:nth-child(2)
    width: vw(46)
    text-align: initial

  div:nth-child(n+3)
    width: vw(38)

.bold
  font-size: bold
</style>
